import React, { useCallback } from 'react';
import { ZendeskHelpCenterForm } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/create/CreateZendeskIntegrationPopup/ZendeskIntegrationForm2/ZendeskHelpCenterForm';
import { ZendeskTicketsForm } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/create/CreateZendeskIntegrationPopup/ZendeskIntegrationForm2/ZendeskTicketsForm';

export const ZendeskIntegrationForm2 = ({
  zendeskIntegrationType,
  prevStep = () => {},
  closePopup = () => {},
  knowledgeBaseId = undefined,
  initialRequest = undefined,
}: {
  zendeskIntegrationType?: any;
  prevStep?: () => void;
  closePopup?: (...args: any[]) => void;
  knowledgeBaseId?: any;
  initialRequest?: any;
}) => {
  const renderForm = useCallback(() => {
    switch (zendeskIntegrationType) {
      case 'Help Center':
        return (
          <ZendeskHelpCenterForm
            zendeskIntegrationType={zendeskIntegrationType}
            prevStep={prevStep}
            closePopup={closePopup}
          />
        );
      case 'Tickets':
        return (
          <ZendeskTicketsForm
            zendeskIntegrationType={zendeskIntegrationType}
            prevStep={prevStep}
            closePopup={closePopup}
          />
        );
    }
  }, [zendeskIntegrationType]);

  return renderForm();
};
